module.exports = __webpack_public_path__ + "media/images/site_files/browserconfig-eeaf2316963a868f108398709925b1be.xml";